module.exports = __webpack_public_path__ + "img/worldpay-from-fis-logo-vector.49fe007a.svg";